/* eslint-disable max-len */

import { defineMessages } from 'react-intl'

export default defineMessages({
  pageTitle: 'Newsroom',
  introTitle: 'The latest news about freshcells',
  introInfo: 'Here you will find all news & press releases from freshcells. We regularly publish news about innovations and successful projects, stay up to date. You are welcome to contact us if you would like to write a press release.'
})
